module.exports = __webpack_public_path__ + "media/assets/images/landing/win-9b7594fd39bb9078d52c9d8bd1b0e51a.png";